import { useContext } from "react";
// my imports:
import { GameManager } from "@/app/lib/game-state/game-manager";
import UI from "@/app/lib/ui/ui";
import { Contexts } from "@/app/components/Context";
import MainTitle from "@/app/components/MainTitle";
import { InternalRouter } from "@/app/lib/routing/internal-router";
import { LevelID } from "@/app/lib/levels/full-story";
// styles
import styles from "@/app/styles/levelMenu.module.css"
import menuStyles from "@/app/styles/menu.module.css"
import animation from "@/app/styles/animation.module.css"

export default function LevelMenu() {
    const gameManager: GameManager | null = useContext(Contexts.GameManager);
    const ui: UI | null = useContext(Contexts.UI);

    if (!gameManager || !ui) {
        console.warn('LevelMenu: missing gameManager or ui context');
        return null;
    }

    const totalLevels: number = gameManager.levels.fullStory.finalLevel;
    let solvedLevels: number = 0;
    for (const snapshot of gameManager.levels.snapshotMap.values()) {
        if (snapshot.victorious) {
            solvedLevels++;
        }
    }

    const iRouter = new InternalRouter(gameManager, ui);
    const animDelayInterval = .025;

    return(
        <>
        <div className='contentGrid'>

            <div className='headerArea'>

                <MainTitle 
                    subtitle={`${solvedLevels}/${totalLevels} solved:`}
                />
            </div>

            <div className="gameArea">
                {gameManager.levels.fullStory.levelDatas.map((levelData, i) => (
                    <div
                        key={i}
                        className={`
                            ${animation.fadeIn}
                            ${animation.fast}
                        `}
                        style={{
                            animationDelay: `${animDelayInterval * i}s`,
                        }}
                    >
                        <span className={styles.levelMenuText}
                            onClick={(e) => {
                                e.stopPropagation();
                                iRouter.goLevelName(levelData.levelName)
                            }}
                        >
                            {
                                gameManager.levels.snapshotMap.get(levelData.levelID)?.victorious ?
                                    '●' :
                                    '○'
                            }
                            &nbsp;{`${levelData.levelName}`}
                        </span>
                    </div>
                ))}
                <div
                    className={`
                            ${animation.fadeIn}
                            ${animation.fast}
                        `}
                        style={{
                            animationDelay: `${animDelayInterval * gameManager.levels.max}s`,
                        }}
                >
                    <button className={`${menuStyles.menuButton} ${styles.backButton}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            iRouter.goPath('/story');
                        }}
                    >
                        back
                    </button>
                </div>
            </div>

            

        </div>
        </>
    )
}